<template>
	<div>
		<el-form ref="form" :model="form" :rules="rules" size="small" label-position="right" label-width="130px">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="姓名" prop="personName">
						<el-input v-model.trim="form.personName"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="身份证号" prop="idCard">
						<el-input v-model.trim="form.idCard"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="工程管理年限" prop="managementYear">
						<el-input v-model.trim="form.managementYear" v-positiveNumber></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="证书类型" prop="certificateType">
						<el-select v-model.trim="form.certificateType" style="width: 100%;" @change="handleCertificateType">
							<el-option
								v-for="item in dictionarys.certificateTypeList"
								:key="item.dictcode"
								:label="item.dictionaryValues"
								:value="item.dictcode"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12" v-if="form.certificateType !== '职称证书'">
					<el-form-item label="注册证书编号" prop="certificateCode">
						<el-input v-model.trim="form.certificateCode"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12" v-if="form.certificateType !== '职称证书'">
					<el-form-item label="注册等级" prop="certificateName">
						<el-select v-model.trim="form.certificateName" style="width: 100%;">
							<el-option
								v-for="item in dictionarys.zcdjList"
								:key="item.dictcode"
								:label="item.dictionaryValues"
								:value="item.dictcode"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12" v-if="form.certificateType !== '职称证书'">
					<el-form-item label="注册专业" prop="registerProject">
						<el-select v-model.trim="form.registerProject" style="width: 100%;" multiple collapse-tags>
							<el-option
								v-for="item in dictionarys.zczytwoList"
								:key="item.dictcode"
								:label="item.dictionaryValues"
								:value="item.dictionaryValues"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="职称等级" prop="professionalLevel">
						<el-select v-model.trim="form.professionalLevel" style="width: 100%;">
							<el-option
								v-for="item in dictionarys.djList"
								:key="item.dictcode"
								:label="item.dictionaryValues"
								:value="item.dictionaryValues"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="职称专业" prop="professionalProject">
						<el-select v-model.trim="form.professionalProject" style="width: 100%;" multiple collapse-tags filterable>
							<el-option
								v-for="item in dictionarys.zczyList"
								:key="item.dictcode"
								:label="item.dictionaryValues"
								:value="item.dictionaryValues"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="负责资质类别" prop="zzCode">
						<el-select v-model="form.zzCode" placeholder="请选择" filterable>
							<el-option
								v-for="item in dictionarys.zzCodeList"
								:key="item.id"
								:label="item.dictionaryValues"
								:value="item.dictcode"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import { getUuid } from '@/utils'
	import { validateIdCard } from '@/utils/jr-validate'
	import { queryCommonDictionary } from '@/api/dictionary/index'

	/**
	 * 技术负责人表单组件
	 */
	export default {
		name: 'Jsfzr',
		components: {},
		props: {
			// 建筑业企业资质选择的资质项信息
			qualificationInfo: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				form: {
					// 主键
					id: '',
					// 姓名
					personName: '',
					// 证件号码
					idCard: '',
					// 工程管理年限
					managementYear: '',
					// 证书类型： 注册证书 职称证书
					certificateType: '',
					// 注册证书编号
					certificateCode: '',
					// 注册等级
					certificateName: '',
					// 注册专业
					registerProject: [],
					// 职称
					professionalLevel: '',
					// 职称专业
					professionalProject: [],
					// 负责资质类别
					zzCode: '',
					// 技术负责人
					personType: '技术负责人'
				},
				rules: {
					personName: { required: true, message: '请输入', trigger: 'blur' },
					idCard: [
						{ required: true, message: '请输入', trigger: 'blur' },
						{ validator: validateIdCard, trigger: 'blur' }
					],
					managementYear: { required: true, message: '请输入', trigger: 'blur' },
					certificateType: { required: true, message: '请选择', trigger: 'change' },
					certificateCode: { required: true, message: '请输入', trigger: 'blur' },
					certificateName: { required: true, message: '请输入', trigger: 'blur' },
					registerProject: { required: true, message: '请输入', trigger: 'blur' },
					professionalLevel: { required: true, message: '请输入', trigger: 'blur' },
					professionalProject: { required: true, message: '请输入', trigger: 'blur' },
					zzCode: { required: true, message: '请选择', trigger: 'change' }
				},
				// 字典集合
				dictionarys: {
					// 职称专业字典
					zczyList: [],
					// 注册专业字典
					zczytwoList: [],
					// 等级字典
					djList: [
						{
							dictionaryValues: '高级',
							dictcode: '高级'
						},
						{
							dictionaryValues: '中级',
							dictcode: '中级'
						},
						{
							dictionaryValues: '初级',
							dictcode: '初级'
						},
						{
							dictionaryValues: '无',
							dictcode: '无'
						}
					],
					certificateTypeList: [
						{
							dictionaryValues: '注册证书',
							dictcode: '注册证书'
						},
						{
							dictionaryValues: '职称证书',
							dictcode: '职称证书'
						}
					],
					// 注册等级
					zcdjList: [
						{
							dictionaryValues: '一级注册建造师',
							dictcode: '一级注册建造师'
						},
						{
							dictionaryValues: '二级注册建造师',
							dictcode: '二级注册建造师'
						},
						{
							dictionaryValues: '一级造价工程师',
							dictcode: '一级造价工程师'
						},
						{
							dictionaryValues: '二级造价工程师',
							dictcode: '二级造价工程师'
						},
						{
							dictionaryValues: '一级注册结构工程师',
							dictcode: '一级注册结构工程师'
						},
						{
							dictionaryValues: '二级注册结构工程师',
							dictcode: '二级注册结构工程师'
						},
						{
							dictionaryValues: '一级注册建筑师',
							dictcode: '一级注册建筑师'
						},
						{
							dictionaryValues: '二级注册建筑师',
							dictcode: '二级注册建筑师'
						}
					],
					// 资质类别字典
					zzCodeList: []
				}
			}
		},
		created() {},
		mounted() {
			this.handleInitDictionary()
		},
		methods: {
			handleCertificateType(val) {
				if (val === '职称证书') {
					this.form.certificateCode = ''
					this.form.certificateName = ''
					this.form.registerProject = []
				}
			},
			handleInitDictionary() {
				// 获取职称专业字典
				queryCommonDictionary({ dictionaryId: '7', cxType: '3' }).then(res => {
					this.dictionarys.zczyList = res.data
				})
				// 获取注册专业
				queryCommonDictionary({ dictionaryId: '8', cxType: '3' }).then(res => {
					this.dictionarys.zczytwoList = res.data
				})
				// 申报资质类别字典
				const params = {
					// 资质等级
					dictionaryId: '1',
					// 查询全部资质
					cxType: '2'
				}
				queryCommonDictionary(params)
					.then(response => {
						this.qualificationLoading = false
						const { data } = response

						if (data && data.length) {
							// 遍历数据给每一个子项添加selected属性
							data.forEach(item => {
								if (item.collection && Array.isArray(item.collection)) {
									item.collection.forEach(subItem => {
										subItem.selected = false
									})
								}
							})
							// zzCodeList为对象数组，现在要取出其中一项的code为107的
							this.dictionarys.zzCodeList = data.filter(item => item.code === '107')[0].collection
						}
					})
					.catch(error => {
						this.dictionarys.zzCodeList = []
					})
			},
			// 表单保存操作（每个列表对应的表单组件必须添加此方法，且必须同名）
			handleSaveInfo() {
				return new Promise(resolve => {
					this.$refs.form.validate(valid => {
						if (valid) {
							if (!this.form.id) {
								// 若无 uuid 则生成 uuid ，作为唯一标识
								this.form.id = getUuid()
							}
							resolve(this.form)
						}
					})
				})
			}
		}
	}
</script>

<style scoped></style>
